import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-operation-speed-dial',
  templateUrl: './mx.table-operation-speed-dial.component.html',
  styleUrls: ['./mx.table-operation-speed-dial.component.scss'],
})
export class MxTableOperationSpeedDialComponent extends MxBaseComponent {
  @Input() items: MenuItem[];
  @Input() visible: boolean;
}
